import React, { useEffect, useState, useRef } from "react";
import HeaderMenu from "../component/Navbar/headermenu";
import CustomFooter from "../component/Footer/customFooter";
import { ChevronDown, ChevronUp, CloudCog } from "lucide-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle, faUser, faUsers } from "@fortawesome/free-solid-svg-icons";
import { accordionData } from "../data/dataTwo";
import { BsInfoCircle, BsCheck2, BsX } from "react-icons/bs";
import { motion, AnimatePresence } from "framer-motion";
import ContactInTouch from "../component/contactInTouch";
import ProofBlock from "../component/ProofBlock";
import faq from "../assets/new-images/faq.png";
import { Helmet } from "react-helmet-async";
import PricingCards from "../component/pricingCards";
import DynamicPricing from "./DynamicPricing";
import Onboard from "../OnBoard/Onboard";
import { featureCategories } from "../data/pricingFeatureCategories";

export default function Pricing() {
  const [isMonthly, setIsMonthly] = useState(true);
  const [isMMonthly, setIsMMonthly] = useState(true);

  const handleToggle = () => {
    setIsMonthly((prev) => !prev);
  };
  const hhandleToggle = () => {
    setIsMMonthly((prev) => !prev);
  };
  const [openTooltip, setOpenTooltip] = useState(null);
  const tooltipRef = useRef(null);

  const toggleTooltip = (id) => {
    setOpenTooltip((prev) => (prev === id ? null : id));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        setOpenTooltip(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const [activeIndex, setActiveIndex] = useState(null);
  const [isOpenTab, setisOpenTab] = useState(0);

  const handleTabClick = (index) => {
    setisOpenTab(index);
    if (index === 1) {
      setIsMMonthly(false);
    } else {
      setIsMMonthly(true);
    }
  };

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      // console.log("aaaa kayu che", index);
      setActiveIndex(null);
    } else {
      setActiveIndex(index);
    }
  };
  const pricingData = {
    user: {
      monthly: {
        free: "₹0",
        Starter: "₹850",
        pro: "₹1,360",
        elite: "₹40",
      },
      yearly: {
        free: "₹0",
        Starter: "₹680",
        pro: "₹1,088",
        elite: "₹400",
      },
    },
    team: {
      monthly: {
        free: "₹0",
        Starter: "₹34,999",
        pro: "₹74,999",
      },
      yearly: {
        free: "₹0",
        Starter: "₹34,999",
        pro: "₹74,999",
      },
    },
  };

  const elementRef = useRef(null);
  const tabRef = useRef(null);
  const [isActive, setIsActive] = useState(false);
  const [isActives, setIsActives] = useState(false);
  const [selectedTitle, setSelectedTitle] = useState("Starter");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const titles = ["Starter", "Pro", "Elite"];

  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
    setIsOpen((prev) => !prev);
  };

  const selectTitle = (title) => {
    setSelectedTitle(title);
    setIsDropdownOpen(false);
  };
  useEffect(() => {
    // document.title = "Pricing - Simplifyte";
    const handleScroll = () => {
      if (!elementRef.current) return;
      const rect = elementRef.current.getBoundingClientRect();
      if (!isActive && rect.top < 88) {
        setIsActive(true);
      }
      if (isActive && rect.top > 79) {
        setIsActive(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isActive]);

  useEffect(() => {
    const handleScrolls = () => {
      if (window.innerWidth > 768) return; // only run on mobile screens
      if (!tabRef.current) return;
      const rects = tabRef.current.getBoundingClientRect();
      // console.log(rects.top);
      if (!isActives && rects.top < 90) {
        setIsActives(true);
      }
      if (isActives && rects.top > 89) {
        setIsActives(false);
      }
    };
    window.addEventListener("scroll", handleScrolls);

    return () => window.removeEventListener("scroll", handleScrolls);
  }, [isActives]);
  return (
    <>
      <Helmet>
        <title>Simplifyte Pricing Plans : Free, Starter, Pro, Elite</title>
        {/* Open Graph meta */}
        <meta
          property="og:title"
          content="Simplifyte Pricing Plans : From Setup to Success - Free, Starter, Pro, Elite"
        />
        <meta
          name="description"
          property="og:description"
          content="Streamline your workflow and accelerate growth with Simplifyte."
        />
        {/* Canonical URL */}
        <link rel="canonical" href="https://www.simplifyte.com/pricing" />
        {/* Viewport for responsive design */}
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        clg
        {/* Keywords for SEO */}
        <meta
          name="keywords"
          content="Simplifyte pricing, Free plan, Starter plan, Pro plan, Elite plan, affordable business tools, subscription pricing, SaaS pricing"
        />
      </Helmet>
      <div>
        <HeaderMenu />
        <section className="relative md:py-24 py-36 pricing-page">
          <div className="container relative">
            <div className="grid grid-cols-1 pb-8 text-center">
              {/* font-size-same mb-2 md:text-3xl md:leading-normal text-2xl leading-normal font-bold */}
              <h1 className="Pricing_Main_Class">From Setup to Success</h1>
              {/* sub-desc-css text-slate-400 max-w-xl mx-auto  */}
              <p className="Pricing_Main_Para_Class">
                Streamline your workflow and accelerate growth with
                <span className="text-[#093a5b] font-extrabold"> Simpli</span>
                <span className="text-[#329BD7] text-[15px]">fyte</span>
              </p>
            </div>

            <div className="grid grid-cols-1">
              {/* className="inline-block w-fit mx-auto flex-wrap justify-center text-center p-2 bg-white dark:bg-slate-900 shadow dark:shadow-gray-800 rounded-full" */}
              <PricingCards
                handleToggle={handleToggle}
                isMonthly={isMonthly}
                setIsMonthly={setIsMonthly}
                isOpenTab={isOpenTab}
                hhandleToggle={hhandleToggle}
                isMMonthly={isMMonthly}
                handleTabClick={handleTabClick}
                tabRef={tabRef}
                isActives={isActives}
              />
              <ProofBlock />
              {/* <div className="relative">
              </div> */}
              <div className="grid grid-cols-1 pb-8 text-center">
                <h1 className="Pricing_Main_Class">From Setup to Success</h1>
                <p className="Pricing_Main_Para_Class">
                  Streamline your workflow and accelerate growth with
                  Simplifyte.
                </p>
              </div>
              <div className="web-view-section">
                <DynamicPricing />
                {featureCategories.map((cat, catIdx) => {
                  const Icon = cat.icon;
                  return (
                    <div
                      key={cat.title}
                      className={catIdx === 0 ? "" : "mt-6"}
                    >
                      <h6 className="flex items-center gap-2 titles-sticky font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
                        <Icon className="text-indigo-600 text-lg" />
                        {cat.title}
                      </h6>

                      <div className="grid lg:grid-cols-4 md:grid-cols-2 mt-6 gap-[30px]">
                        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                          <ul className="list-none text-slate-400">
                            {cat.rows.map((row, rowIdx) => (
                              <li
                                key={row.label}
                                className={`mb-3 flex items-center ms-0 pricing-item-inner-div${rowIdx === 0 ? " master_margin" : ""}`}
                              >
                                <span>{row.label}</span>
                                <span className="info-popup">
                                  <BsInfoCircle className="pricing-item-inner-div-info" />
                                </span>
                                <div className="pricing-popup">
                                  <div className="name-desg-sec">
                                    <span className="name-sec">
                                      {row.tooltip}
                                    </span>
                                  </div>
                                </div>
                              </li>
                            ))}
                          </ul>
                        </div>

                        {["starter", "pro", "elite"].map((planKey) => (
                          <div
                            key={planKey}
                            className={
                              planKey === "pro"
                                ? "business-content group border-b-[3px] border-indigo-600 px-1 p-6 py-8 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl bg-white dark:bg-slate-900 h-fit"
                                : "enterprise-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit"
                            }
                          >
                            <ul className="list-none text-slate-400">
                              {cat.rows.map((row) => {
                                
                                const val = row[planKey];
                                return (
                                  <li
                                    key={row.label}
                                    className="mb-3 flex items-center ms-0 pricing-item-inner-div"
                                  >
                                    {val.type === "check" && (
                                      <BsCheck2 className="pricing-item-inner-div-check" />
                                    )}
                                    {val.type === "cross" && (
                                      <BsX className="pricing-item-inner-div-check cross-check" />
                                    )}
                                    {val.type === "text" && <>{" "}{val.text}</>}
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                        ))}
                      </div>
                    </div>
                  );
                })}
              </div>

              

              <div className="mobile-view-section">
                <div className="mobile-box">
                  {/* Dropdown */}
                  {/* <div className="m-width my-5"> */}
                  <div
                    ref={elementRef}
                    className={`m-width my-5 my-element ${isActive ? "active" : ""
                      }`}
                  >
                    <button
                      onClick={toggleDropdown}
                      className="pad-t w-full flex items-center justify-between px-4 py-2 bg-indigo-100 text-indigo-600 font-bold uppercase rounded-xl hover:bg-indigo-200"
                    >
                      {selectedTitle}
                      {isOpen ? (
                        <ChevronUp className="w-4 h-4" />
                      ) : (
                        <ChevronDown className="w-4 h-4" />
                      )}
                    </button>
                    {isDropdownOpen && (
                      <div className="absolute w-full mt-2 bg-white border border-gray-300 rounded-xl shadow-lg m-dropdown">
                        <ul className="text-sm text-gray-700">
                          {titles.map((title) => (
                            <li
                              key={title}
                              onClick={() => selectTitle(title)}
                              className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                            >
                              {title}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>

                  {/* Content Display */}
                  <div className="feature-content">
                    {featureCategories.map((cat, catIdx) => {
                      const Icon = cat.icon;
                      const planKey = selectedTitle.toLowerCase();

                      return (
                        <div key={cat.title}>
                          <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
                            <Icon className="text-indigo-600 text-lg" />
                            {cat.title}
                          </h6>
                          <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                            <ul className="list-none text-slate-400">
                              {cat.rows.map((row, rowIdx) => {
                                const val = row[planKey];
                                const tooltipId = `${catIdx}-${rowIdx}`;

                                return (
                                  <li
                                    key={row.label}
                                    ref={tooltipRef}
                                    className="mb-3 flex items-center ms-0 pricing-item-inner-div"
                                  >
                                    <span className="flex items-center">
                                      {row.label}
                                      <BsInfoCircle
                                        className="ml-4 pricing-item-inner-div-info"
                                        onClick={() => toggleTooltip(tooltipId)}
                                      />
                                      {openTooltip === tooltipId && (
                                        <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                                          {row.tooltip}
                                        </div>
                                      )}
                                    </span>
                                    <span>
                                      {val.type === "check" && (
                                        <BsCheck2 className="pricing-item-inner-div-check" />
                                      )}
                                      {val.type === "cross" && (
                                        <BsX className="pricing-item-inner-div-check cross-check" />
                                      )}
                                      {val.type === "text" && val.text}
                                    </span>
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <section
            className="relative overflow-hidden"
            style={{ marginTop: "30px" }}
          >
            <div className="container relative md:mt-12 mt-12">
              <div className="grid md:grid-cols-2 grid-cols-1 items-end">
                <div className="relative order-1 md:order-2 c-padding">
                  <img src={faq} className="rounded-lg" alt="Simplifyte" />
                </div>

                <div className="lg:me-8 order-2 md:order-1 mrgin-out">
                  {/* font-size-same mb-4 md:text-3xl text-2xl lg:leading-normal leading-normal font-semibold c-margin  */}
                  <h4 className="Pricing_Class_Support">
                    If you need help, <br /> we're here for you
                  </h4>

                  <div
                    id="accordion-collapseone"
                    data-accordion="collapse"
                    className="mt-6 scrollable-faq"
                  >
                    {accordionData.slice(0, 11).map((item, index) => (
                      <div
                        key={index}
                        className="relative shadow dark:shadow-gray-800 rounded-xl overflow-hidden mt-4"
                      >
                        <h2
                          className="text-base font-semibold"
                          id="accordion-collapse-heading-1"
                        >
                          <button
                            type="button"
                            onClick={() => toggleAccordion(index)}
                            className={`flex justify-between items-center p-5 w-full font-medium text-start ${activeIndex === index
                              ? "bg-gray-50 dark:bg-slate-800 text-indigo-600"
                              : ""
                              }`}
                            data-accordion-target="#accordion-collapse-body-1"
                            aria-expanded="true"
                            aria-controls="accordion-collapse-body-1"
                          >
                            <span>{item.title}</span>
                            <svg
                              data-accordion-icon
                              className={`${activeIndex === index
                                ? "rotate-180"
                                : "rotate-270"
                                } size-4 shrink-01`}
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fillRule="evenodd"
                                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                clipRule="evenodd"
                              ></path>
                            </svg>
                          </button>
                        </h2>
                        {activeIndex === index && (
                          <div>
                            <div className="p-5">
                              <p className="text-slate-400 dark:text-gray-400">
                                {item.content}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* <ContactInTouch title={true} /> */}
          <Onboard />
        </section>

        <CustomFooter />
      </div>
    </>
  );
}
